;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="fe9716ba-2d96-4832-acec-57b2704ff5ee",e._sentryDebugIdIdentifier="sentry-dbid-fe9716ba-2d96-4832-acec-57b2704ff5ee")}catch(e){}}();import '../_virtual/_sentry-release-injection-file.js';

var CategoryTypeEnum;
(function (CategoryTypeEnum) {
    CategoryTypeEnum["NORMAL"] = "NORMAL";
    CategoryTypeEnum["ANIMAL"] = "ANIMAL";
    CategoryTypeEnum["BRANDS"] = "BRANDS";
    CategoryTypeEnum["OFFERS"] = "OFFERS";
    CategoryTypeEnum["SPECIAL_OFFERS"] = "SPECIAL_OFFERS";
    CategoryTypeEnum["TRIAL_OFFERS"] = "TRIAL_OFFERS";
    CategoryTypeEnum["NEW_PRODUCTS"] = "NEW_PRODUCTS";
    CategoryTypeEnum["OUTLET"] = "OUTLET";
})(CategoryTypeEnum || (CategoryTypeEnum = {}));

export { CategoryTypeEnum };
//# sourceMappingURL=index.js.map
